export class RateChange {
  price: number;
  startDate: Date;
  endDate: Date;

  constructor(price: number, startDate: Date, endDate: Date) {
    this.price = price;
    this.startDate = startDate;
    this.endDate = endDate;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/rate/rate-change.model.ts